import request from '@/utils/request'

//留言板
export function getRemarkList(data) {
  return request({
    url: '/api/contencommentsboard/list',
    method: 'post',
    data
  });
}
//留言
export function getSave(data) {
  return request({
    url: '/api/contencommentsboard/save',
    method: 'post',
    data
  });
}
//获取问卷列表
export function getPaperList(params) {
  return request({
    url: '/api/examine/examinepaper/getPaperList',
    method: 'get',
    params
  });
}
//获取问卷详情
export function getPaper(params) {
  return request({
    url: '/examine/api/getPaper',
    method: 'get',
    params
  });
}
//提交问卷不需要手机号
export function submitPaperNoTel(data) {
  return request({
    url: '/examine/api/submitPaperNoTel',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/consult/index.js